/**
 * ## cortex:std:ApplicationError
 * Custom error type to throw when application flow fails.
 */
export class ApplicationError extends Error {
	constructor(public message: string) {
		super(message);
		this.name = 'ApplicationError';
		Object.setPrototypeOf(this, ApplicationError.prototype);
	}
}
